<template>
	<div class="goods-list" v-loading="loading">

		<div class="block-container">
			<div class="box category">
				<div class="name">产品分类:</div>
				<div class="value">
					<!-- <span @click="load()">刷新</span> -->
					<!-- <div class=""></div> -->
					<!-- <div class="row" > -->
						<div class="cat1" >
							<el-tag v-for="(cat1,i) in categoryList" :key="cat1.category_id"  :closable="filters.category1 == cat1.category_id" :effect="filters.category1 == cat1.category_id?'dark':'plain'"
							 @click="selectCat(cat1.category_id,cat1.level)" @close="selectCat(0,0)">
							{{cat1.category_name}}
							</el-tag>
						</div>
						<div class="cat2" v-for="(cat1,i) in categoryList" :key="'cat1_'+cat1.category_id" v-if="filters.category1 == cat1.category_id">
							<el-tag v-for="cat2 in cat1.child_list" :key="cat2.category_id" :closable="filters.category2 == cat2.category_id" :effect="filters.category2 == cat2.category_id?'dark':'plain'"
							@click="selectCat(cat2.category_id,cat2.level)" @close="selectCat(cat1.category_id,cat1.level)">
							{{cat2.category_name}}
							</el-tag>
						</div>
						<div v-for="(cat1,i) in categoryList" :key="'cat1_1_'+cat1.category_id" v-if="filters.category1 == cat1.category_id">
							<div class="cat3" v-for="cat2 in cat1.child_list" :key="'cat2_'+cat2.category_id" v-if="filters.category2 == cat2.category_id">
								<el-tag v-for="cat3 in cat2.child_list" :key="cat3.category_id" :closable="filters.category3 == cat3.category_id" :effect="filters.category3 == cat3.category_id?'dark':'plain'"
								@click="selectCat(cat3.category_id,cat3.level)" @close="selectCat(cat2.category_id,cat2.level)">
								{{cat3.category_name}}
								</el-tag>
							</div>
						</div>
					<!-- </div> -->
				</div>
			</div>
			<div class="box brand">
				<div class="name">品牌:</div>
				<div class="value">
					<div class="brand-list">
						<el-card v-for="item in brandList" :key="item.id" body-style="padding: 0;height: 100%;" shadow="hover" v-show="currentInitial === '' || item.brand_initial === currentInitial"
						 class="brand-item" :class="{active:filters.brand_id==item.brand_id}">
							<el-image :src="$img(item.image_url || defaultGoodsImage)" :alt="item.brand_name" :title="item.brand_name" fit="contain"
							 @click="onChooseBrand(item)" />
						</el-card>
					</div>
					
				</div>
			</div>
		</div>

		<!-- 搜索关键字 -->
		<div class="search_bread" v-if="keyword">
			<span>搜索结果：</span>
			<span class="keyword">'{{ keyword}}'</span>
		</div>
		<div class="search_bread" v-else-if="!keyword && catewords">
			<span>搜索结果:：</span>
			<span class="keyword">'{{ catewords}}'</span>
		</div>

		<!-- 分类-->

		<!-- <div class="cat">
			<div class="category" >
				<div class="brand">
					<div class="table_head">分类：</div>
					<div class="table_body">
						<div class="initial">
							<span type="info" effect="plain" hit @mouseover="handleChangeInitial('')">所有品牌</span>
						</div>
						<div class="content">
							<span v-for="(cat,i) in categoryList" :key="i">
								{{cat.category_name}}
							</span>
						</div>
					</div>
				</div>
			</div>
		</div> -->

		<div class="list-wrap">

			<div class="list">
				<!-- 排序筛选区 -->
				<div>
					<div class="sort">
						<div class="item" @click="changeSort('')" :class="{ active: filters.order==''}">
							<div class="item-name">综合</div>
						</div>
						<div class="item" @click="changeSort('sale_num')" :class="{ active: filters.order=='sale_num'}">
							<div class="item-name">销量</div>
							<i v-if="filters.order === 'sale_num' && filters.sort === 'desc'" class="el-icon-arrow-down el-icon--down" />
							<i v-else class="el-icon-arrow-up el-icon--up" />
						</div>
						<div class="item" @click="changeSort('discount_price')" :class="{ active: filters.order=='discount_price'}">
							<div class="item-name">价格</div>
							<i v-if="filters.order === 'discount_price' && filters.sort === 'desc'" class="el-icon-arrow-down el-icon--down" />
							<i v-else class="el-icon-arrow-up el-icon--up" />
						</div>
						<!-- <div class="item-other">
						  <el-checkbox label="包邮" v-model="is_free_shipping"></el-checkbox>
						</div> -->
						<!-- <div class="item-other">
							<el-checkbox label="自营" v-model="is_own"></el-checkbox>
						</div> -->
						<div class="input-wrap">
							<div class="price_range">
								<el-input placeholder="最低价格" size="small" v-model="filters.min_price"></el-input>
								<span>—</span>
								<el-input placeholder="最高价格" size="small" v-model="filters.max_price"></el-input>
							</div>
							<el-button plain size="mini" @click="handlePriceRange">确定</el-button>
						</div>
					</div>
				</div>
				<div class="cargo-list" v-if="cargoList.length">
					<div class="goods-info">
						<div class="item" v-for="(item, index) in cargoList" :key="item.goods_id" @click="$router.pushToTab({ path: '/sku-' + item.sku_id })">
							<img class="img-wrap" :src="$img(item.sku_image, { size: 'mid' })" @error="imageError(index)" />
							<div class="price-wrap">
								<div class="price price-color">
									<p>￥</p>
									{{ item.discount_price }}
								</div>
								<div class="market-price">￥{{ item.market_price }}</div>
							</div>
							<div class="goods-name">{{ item.goods_name }}</div>
							<div class="sale-num">
								销量<p>{{ item.sale_num || 0 }}</p>&nbsp;&nbsp;
								<p>{{ item.click_num || 0 }}</p>人浏览
							</div>
							<div class="shop_name">{{item.site_name}}</div>
							<div class="saling">
								<!-- <div class="free-shipping" v-if="item.is_free_shipping == 1">包邮</div> -->
								<!-- <div class="is_own" v-if="item.is_own == 1">自营</div> -->
								<div class="promotion-type" v-if="item.promotion_type == 1">限时折扣</div>
							</div>
							<!-- <div class="item-bottom">
                  <div v-if="!item.isCollection" class="collection" @click.stop="editCollection(item)">
                    <i class="iconfont iconlike"></i>
                    收藏
                  </div>
				  <div v-if="item.isCollection" class="collection" @click.stop="editCollection(item)">
                    <i class="iconfont iconlikefill ns-text-color"></i>
                    取消收藏
                  </div>
                  <div class="cart" @click.stop="addToCart(item)">
                    <i class="el-icon-shopping-cart-2"></i>
                    加入购物车
                  </div>
              </div>-->
						</div>
					</div>
					<div class="pager">
						<el-pagination background :pager-count="5" :total="total" prev-text="上一页" next-text="下一页" :current-page.sync="currentPage"
						 :page-size.sync="pageSize" @size-change="handlePageSizeChange" @current-change="handleCurrentPageChange"
						 hide-on-single-page></el-pagination>
					</div>
				</div>
				<div class="empty" v-else>
					<div class="ns-text-align">没有找到您想要的商品。换个条件试试吧</div>
				</div>
			</div>

			<div class="goods-recommended" v-if="cargoList.length">
				<goods-recommend :page-size="cargoList.length < 5 ? 2 : 5" />
			</div>

		</div>
	</div>
</template>

<script>
	import BreadCrumbs from "@/components/BreadCrumbs";
	import GoodsRecommend from "@/components/GoodsRecommend";
	import list from "./list";

	export default {
		name: "list",
		components: {
			BreadCrumbs,
			GoodsRecommend
		},
		data: () => {
			return {};
		},
		mixins: [list],
		created() {},
		methods: {}
	};
</script>

<style lang="scss" scoped>
	.goods-list {
		background: #fff;
		padding-top: 10px;
	}

	.search_bread {
		display: inline-block;
		font-size: 14px;
		margin: 0px auto;
		width: 100%;
		padding: 10px;
	}

	.selected_border {
		border: 1px solid $base-color;
	}

	.attr_filter {
		.el-tag {
			margin-right: 5px;
			margin-bottom: 10px;
			border-radius: 0;

			.title {
				color: $base-color;
				font-size: 15px;
			}
		}
	}
	
	.category {
		margin: 0 auto 10px auto;
	}
	
	.list-wrap {
		overflow: hidden;
		display: flex;

		.list {
			// float: left;
			flex: 1;
		}

		.goods-recommended {
			width: 200px;
			background-color: #fff;
			// float: left;
			margin-left: 10px;
		}
	}



	.sort {
		display: flex;
		align-items: center;
		.active{
			background: #003ddb;
			color:#fff;
		}
		.item {
			display: flex;
			align-items: center;
			padding: 5px 15px;
			border: 1px solid #f1f1f1;
			border-left: none;
			cursor: pointer;

			&:hover {
				background: $base-color;
				color: #fff;
			}
		}

		.item-other {
			display: flex;
			align-items: center;
			padding: 5px 15px;
			border: 1px solid #f1f1f1;
			border-left: none;
			cursor: pointer;
		}

		.input-wrap {
			display: flex;
			align-items: center;

			.price_range {
				margin-left: 60px;
			}

			span {
				padding-left: 10px;
			}

			.el-input {
				width: 150px;
				margin-left: 10px;
			}

			.el-button {
				margin: 0 17px;
			}
		}

		>div:first-child {
			border-left: 1px solid #f1f1f1;
		}
	}

	.goods-info {
		margin-top: 5px;
		display: flex;
		flex-wrap: wrap;

		.item {
			width: 220px;
			margin: 10px 20px 0 0;
			border: 1px solid #eeeeee;
			padding-top: 10px;
			position: relative;
			padding-bottom: 5px;

			&:nth-child(4n) {
				margin-right: initial !important;
			}

			&:hover {
				border: 1px solid $base-color;
			}

			.img-wrap {
				width: 198px;
				height: 198px;
				cursor: pointer;
				padding: 10px;
			}

			.goods-name {
				padding: 0 10px;
				overflow: hidden;
				text-overflow: ellipsis;
				display: -webkit-box;
				-webkit-box-orient: vertical;
				-webkit-line-clamp: 2;
				word-break: break-all;
				height: 50px;
				cursor: pointer;

				&:hover {
					color: $base-color;
				}
			}

			.price-wrap {
				padding: 0 10px;
				display: flex;
				align-items: center;

				.price {
					display: flex;
					color: $base-color;
					font-size: $ns-font-size-lg;

					p {
						font-size: $ns-font-size-base;
						display: flex;
						align-items: flex-end;
					}
				}

				.market-price {
					color: #838383;
					text-decoration: line-through;
					margin-left: 10px;
				}
			}

			.sale-num {
				padding: 0 10px;
				display: flex;
				color: #838383;
				font-size: $ns-font-size-sm;

				p {
					color: #4759a8;
				}
			}

			.shop_name {
				padding: 0 10px;
				display: flex;
				color: #838383;
			}

			.saling {
				padding: 0 10px;
				display: flex;
				font-size: $ns-font-size-sm;
				line-height: 1;

				.free-shipping {
					background: $base-color;
					color: #ffffff;
					padding: 3px 4px;
					border-radius: 2px;
					margin-right: 5px;
				}

				.is_own {
					color: #ffffff;
					background: #ff850f;
					border: 1px solid;
					margin-right: 5px;
					display: flex;
					align-items: center;
					padding: 3px 4px;
					border-radius: 2px;
				}

				.promotion-type {
					color: $base-color;
					border: 1px solid $base-color;
					display: flex;
					align-items: center;
					padding: 1px 3px;
				}
			}

			.item-bottom {
				display: flex;
				margin-top: 5px;

				.collection {
					flex: 1;
					border: 1px solid #e9e9e9;
					border-right: none;
					border-left: none;
					height: 40px;
					display: flex;
					align-items: center;
					justify-content: center;
					cursor: pointer;
				}

				.cart {
					flex: 2;
					border: 1px solid #e9e9e9;
					border-right: none;
					height: 40px;
					display: flex;
					align-items: center;
					justify-content: center;
					cursor: pointer;
				}
			}
		}
	}

	.empty {
		margin-top: 45px;
	}

	.pager {
		text-align: center;
		margin-top: 30px;
	}

	.block-container {
		border: 1px solid #eeeeee;
		
		.box {
			display: block;
			// overflow: hidden;
			display: flex;
			flex-wrap: wrap;

			.name {
				width: 150px;
				padding: 10px;
			}

			.value {
				flex: 1;
				padding-bottom: 10px;

				.el-tag {
					margin: 10px 0 0 10px;
					border: 0;
					border-radius: 0;
					cursor: pointer;
				}

				.el-tag--plain {
					// background-color: ;
					color: #000;
				}
			}
		}

		.category {
			.row {
				display: flex;
				flex-wrap: wrap;
				border-bottom: 1px solid #eee;
				padding-bottom: 10px;
				margin-right: 10px;
				.cat1 {
					// width: 130px;
				}
				.cat2{
					// flex: 1;
				}
			}
		}
		
		.brand {
			border-bottom: 1px solid #eeeeee;
			display: flex;
			flex-direction: row;
			
			.value{
				// display: flex;
				.brand-list{
					flex-wrap: wrap;
					display: flex;
					flex-direction: row;
					// position: absolute;
					// justify-content: center;
					.brand-item:hover{
						border:2px solid #003ddb;
					}
					.el-card{
						width: 120px;
						height: 60px;
						padding: 5px;
						box-sizing: border-box;
						cursor: pointer;
						
						.el-image{
							width: 100%;
							height: 100%;
						}
					}
					.active{
						// background-color: #CC7832;
						border: 2px solid #FFC107;
					}
				}
				
			}
		
			
		}
	}
</style>
